import { Dependency, DefaultDependencySettings } from "index";

import ConsentMode from "./../../extentions/consentMode";
import DependencyBase from "./../DependecyBase";
import React from "react";

declare global {
    interface Window {
        Cookiebot?: any;
    }

    interface EventTarget {
        Cookiebot?: any;
    }
}

export interface CookiebotSettings extends DefaultDependencySettings {
    cbid: string;
    consentModeEnabled: boolean;
    helmetComponent: React.ComponentType; // This is the wrong type, this needs to be fixed (wrong in everywhere in package).
}

class Cookiebot extends DependencyBase<CookiebotSettings> {
    static instance: Cookiebot | undefined = undefined;

    // This feels like a bit of a hack...
    static _componentDependencies: Dependency[] = [];
    public static dependency = () => this._componentDependencies.every((dependency) => dependency());

    constructor(prop: CookiebotSettings) {
        super(prop);
        Cookiebot._componentDependencies.push(this.dependency);
        Cookiebot.instance = this;
    }

    public dependency = () => !!window?.Cookiebot?.consent?.method;

    public static onScriptLoaded = () => {
        window.addEventListener(
            "CookiebotOnConsentReady",
            ({ target }) => {
                ConsentMode.update({
                    ad_storage: target?.Cookiebot?.consent?.marketing ? "granted" : "denied",
                    ad_user_data: target?.Cookiebot?.consent?.marketing ? "granted" : "denied",
                    ad_personalization: target?.Cookiebot?.consent?.marketing ? "granted" : "denied",
                    analytics_storage: target?.Cookiebot?.consent?.statistics ? "granted" : "denied",
                    functionality_storage: target?.Cookiebot?.consent?.preferences ? "granted" : "denied",
                    personalization_storage: target?.Cookiebot?.consent?.preferences ? "granted" : "denied",
                    security_storage: "granted",
                });
            },
            false,
        );
    };

    render = () => {
        const { cbid, helmetComponent: Helmet } = this.props as CookiebotSettings;

        return (
            <Helmet>
                <script>
                    {`
                    (function() {
                        const elements = document.getElementsByTagName('script')[0];
                        const script = document.createElement('script');
                        script.onload = function () { return window.grebban.gtm.scriptCallback('Cookiebot'); }
                        script.src = 'https://consent.cookiebot.com/uc.js';
                        script.type = 'text/javascript';
                        script.id = 'Cookiebot'
                        script.setAttribute('data-cbid', '${cbid}')
                        elements.parentNode.insertBefore(script, elements);
                    })();
                `}
                </script>
            </Helmet>
        );
    };
}

export default Cookiebot;
